/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  VALUE_CHANGED,
  LOAD,
  UPLOAD_FILE,
  UPLOAD_PERCENTAGE,
  UPLOAD_PROGRESS_VISIBILITY,
  UPLOAD_FILE_SUCCESS,
  REMOVE_FILE,
  REMOVE_FILE_SUCCESS,
  LOAD_CLAIM_ATTACHMENTS,
  LOAD_CLAIM_ATTACHMENTS_SUCCESS,
  RESET,
  UPLOAD_FILE_DOC,
  VALIDATE_FILE,
  RUN_REQUIRED_DOC_VALIDATION,
  CANCEL_REQUIRED_DOC_VALIDATION,
  RUN_REQUIRED_DOC_VALIDATION_SUCCESS,
  LOAD_VALIDATION_MESSAGES,
  NEXT,
} from './constants';

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function uploadFile(files, benefitCode, documentDescription) {
  return {
    type: UPLOAD_FILE,
    files,
    benefitCode,
    documentDescription,
  };
}

export function runRequiredDocValidation(attachmentIds, requiredDocumentId, claimTypeId) {
  return {
    type: RUN_REQUIRED_DOC_VALIDATION,
    attachmentIds,
    requiredDocumentId,
    claimTypeId,
  };
}

export function cancelRequiredDocValidation(requiredDocumentId, claimTypeId) {
  return {
    type: CANCEL_REQUIRED_DOC_VALIDATION,
    requiredDocumentId,
    claimTypeId
  };
}


export function runRequiredDocValidationSuccess(data) {

  return {
    type: RUN_REQUIRED_DOC_VALIDATION_SUCCESS,
    data,
  };
}

export function uploadRequireDocFile(files, uploadRequest) {
  return {
    type: UPLOAD_FILE_DOC,
    files,
    uploadRequest,
  };
}

export function uploadProgress(percent) {
  return {
    type: UPLOAD_PERCENTAGE,
    percent,
  };
}

export function uploadProgressVisibility(visible) {
  return {
    type: UPLOAD_PROGRESS_VISIBILITY,
    visible,
  };
}

export function uploadFileSuccess(fileInfo) {
  const { file, attachmentId, benefitCode } = fileInfo;
  file.id = attachmentId;
  file.benefitCode = benefitCode;
  file.requiredDocumentId = 0;
  file.groupName = 'Other Supporting Document';
  return {
    type: UPLOAD_FILE_SUCCESS,
    file,
  };
}

export function uploadRequiredFileSuccess(fileInfo) {
  const { file, attachmentId, uploadRequest, message } = fileInfo;
  file.id = attachmentId;
  file.benefitCode = uploadRequest.benefitCode;
  file.requiredDocumentId = uploadRequest.requiredDocumentId;
  file.claimExpenseGuid = uploadRequest.claimExpenseGuid;
  file.displayCode = uploadRequest.displayCode;
  file.groupName = uploadRequest.groupName || '';
  file.message = message;

  return {
    type: UPLOAD_FILE_SUCCESS,
    file: file,
  };
}

export function validateFile(result) {
  const { file, attachmentId, message, success } = result;
  file.message = message;
  file.success = success;
  file.id = attachmentId;

  return {
    type: VALIDATE_FILE,
    file,
  };
}

export function removeFile(file) {
  return {
    type: REMOVE_FILE,
    file,
  };
}

export function removeFileSuccess(file) {
  return {
    type: REMOVE_FILE_SUCCESS,
    file,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function loadClaimAttachments() {
  return {
    type: LOAD_CLAIM_ATTACHMENTS,
  };
}

export function loadClaimAttachmentsSuccess(files) {
  return {
    type: LOAD_CLAIM_ATTACHMENTS_SUCCESS,
    files,
  };
}

export function loadValidationMessageSuccess(message) {
  return {
    type: LOAD_VALIDATION_MESSAGES,
    message,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSupportingDocuments/actions.js